export default "__VITE_ASSET__B3yZ6Mwk__"